<template>
  <template v-if="title == 'Rank'">
    <template v-if="value.rank === 1">
      <img class="medal-icon" src="@/assets/imgs/ranking/medal-1.webp" />
    </template>
    <template v-else-if="value.rank === 2">
      <img class="medal-icon" src="@/assets/imgs/ranking/medal-2.webp" />
    </template>
    <template v-else-if="value.rank === 3">
      <img class="medal-icon" src="@/assets/imgs/ranking/medal-3.webp" />
    </template>
    <template v-else>
      {{ value.rank }}
    </template>
  </template>
  <template v-else-if="title == 'Character'">
    <img class="character" :src="value.characterImgURL" />
  </template>
  <template v-else-if="['Character Name', 'Name'].includes(title)">
    {{ value.characterName }}
  </template>
  <template v-else-if="title == 'Name/Job'">
    <b>{{ value.characterName }}</b>
    <div>{{ value.jobName }}</div>
  </template>
  <template v-else-if="title == 'World'">
    <RouterLink
      :to="{
        params: { type: 'world-ranking', filter: worldListRef.find((x) => x.name === value.worldName)?.key },
      }"
      ><RankingWorldIcon :value="value.worldName"
    /></RouterLink>
  </template>
  <template v-else-if="title == 'Job'">
    <RouterLink
      :to="{
        params: {
          type: 'job-ranking',
          filter: rankingFiltersRef.find((x) => x.key === 'job')?.children?.find((x) => x.name == value.jobName)
            ?.filter,
          filter2: rankingFiltersRef.find((x) => x.key === 'job')?.children?.find((x) => x.name == value.jobName)?.key,
        },
        query: {
          world_type: route.query.world_type ?? 'both',
        },
      }"
      ><img
        :alt="value.jobName"
        class="job-icon"
        :src="`//nxcache.nexon.net/maplestory/img/icons/2024/icon-job-${snakeCase(value.jobName)}.gif`"
        :title="value.jobName"
    /></RouterLink>
  </template>
  <template v-else-if="title == 'Level/Move'">
    <div>{{ new Intl.NumberFormat().format(value.level) }}</div>
    <div>{{ new Intl.NumberFormat().format(value.gap) }}</div>
  </template>
  <template v-else-if="title == 'Exp Gained'">
    {{ new Intl.NumberFormat().format(value.gap) }}
  </template>
  <template v-else-if="title == 'Tier'">
    <img
      :alt="getTierName(value.tierID)"
      class="tier-icon"
      :src="`//nxcache.nexon.net/maplestory/assets-new/img/tier/${getTierName(value.tierID).toLowerCase()}.png`"
    />
  </template>
  <template v-else-if="title == 'Score'">
    {{ new Intl.NumberFormat().format(value.starSum) }}
  </template>
  <template v-else-if="title == 'Fame Gained'">
    {{ new Intl.NumberFormat().format(value.exp) }}
  </template>
  <template v-else-if="title == 'Total Fame'">
    {{ new Intl.NumberFormat().format(value.exp) }}
  </template>
  <template v-else-if="title == 'Legion Level'">
    {{ new Intl.NumberFormat().format(value.legionLevel) }}
  </template>
  <template v-else-if="title == 'Raid Power'">
    {{ new Intl.NumberFormat().format(value.raidPower) }}
  </template>
</template>
<script setup lang="ts">
  import { RankInfo } from '@/store/rankings'
  import { snakeCase } from 'change-case'
  import worldList from '@/config/rankings/world'
  import { rankingFilters } from '@/config/rankings'
  import { Tiers } from '@/config/rankings/tier'

  defineProps({
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Object as PropType<RankInfo>,
      required: true,
    },
  })

  const route = useRoute()

  const getTierName = (id: number) => {
    return Tiers[id] ?? 'Unknown'
  }

  const worldListRef = ref(worldList)
  const rankingFiltersRef = ref(rankingFilters)
</script>
<style lang="scss" scoped>
  .medal-icon {
    width: 35px;
  }
  .tier-icon {
    width: 40px;
  }
  @media #{$mobile} {
    .medal-icon {
      width: pxToRemMobile(35);
    }
    .tier-icon {
      width: pxToRemMobile(40);
    }
  }
</style>
